import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import _ from 'lodash';

import { TitledCard } from 'Components/';
import { Filter, Main } from 'Containers';
import { Provision2FieldEnum as Fields } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { PROVISION2_FORM_NAME } from 'Common/FormEnum';
import {
  errorToast,
  successToast,
  createToast,
  toastType,
} from 'Common/ToastHelper';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { MealTypeEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import * as CommonStateSelectors from 'State/selectors';
import * as ControlInfoActions from 'State/controlInfo/actions';

import { Provision2Form } from './components/Provision2Form';
import * as Provision2Actions from './state/actions';
import * as Provision2Selectors from './state/selectors';

class Provision2 extends React.Component {
  path = '/provision2';

  initialValues = {
    [Fields.ServingDate]: moment().format(DATE_FORMAT_FOR_UI),
  };

  componentDidMount() {
    this.props.getControlInfo();
  }

  componentDidUpdate(prevProps) {
    const { resetWriteError, resetWriteSuccessful } = this.props;

    errorToast(this.props, prevProps, 'writeError', resetWriteError);
    successToast(
      this.props,
      prevProps,
      'writeSuccessful',
      'Provision 2 Meal Values Processed',
      resetWriteSuccessful
    );
  }

  get mainProps() {
    const { loadingWriteMeals, loadingCalculation } = this.props;
    return {
      toolbox: {
        shown: true,
        saveButtonProps: {
          disabled: loadingWriteMeals || loadingCalculation,
          content: 'Process',
          loading: loadingWriteMeals,
        },
        formName: PROVISION2_FORM_NAME,
      },
    };
  }

  createMessage(values) {
    const { sitesMap, itemsMap } = this.props;
    const site = sitesMap[values[Fields.SiteId]];
    const item = itemsMap[values[Fields.ItemId]];

    if (!site || !item) {
      return null;
    }

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column textAlign="right" width={3}>
            Meal Type:
          </Grid.Column>
          <Grid.Column width={13}>
            {values[Fields.MealType] === MealTypeEnum.Breakfast
              ? 'Breakfast'
              : 'Lunch'}
          </Grid.Column>
          <Grid.Column textAlign="right" width={3}>
            Participation:
          </Grid.Column>
          <Grid.Column width={13}>
            {values[Fields.ParticipationNumber]}
          </Grid.Column>
          <Grid.Column textAlign="right" width={3}>
            Serving Date:
          </Grid.Column>
          <Grid.Column width={13}>
            {moment(values[Fields.ServingDate]).format(DATE_FORMAT_FOR_UI)}
          </Grid.Column>
          <Grid.Column textAlign="right" width={3}>
            Site:
          </Grid.Column>
          <Grid.Column width={13}>
            {site.Id} {site.Description}
          </Grid.Column>
          <Grid.Column textAlign="right" width={3}>
            Item:
          </Grid.Column>
          <Grid.Column width={13}>
            {item.ItemId} {item.Description}
          </Grid.Column>
          <Grid.Column textAlign="right" width={3}>
            Free:
          </Grid.Column>
          <Grid.Column width={13}>{values[Fields.Free]}</Grid.Column>
          <Grid.Column textAlign="right" width={3}>
            Reduced:
          </Grid.Column>
          <Grid.Column width={13}>{values[Fields.Reduced]}</Grid.Column>
          <Grid.Column textAlign="right" width={3}>
            Paid:
          </Grid.Column>
          <Grid.Column width={13}>{values[Fields.Paid]}</Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  showVerifyDialog = values => {
    const { setNotificationDialog, writeProvision2Meals } = this.props;

    const message = this.createMessage(values);

    if (!message) {
      return createToast(
        toastType.error,
        'Error',
        'There was an issue, please try again.'
      );
    }

    setNotificationDialog({
      ...NOTIFICATION_DIALOG_MESSAGES.PROVISION2_PROCESS_MEALS,
      message,
      actionsToDispatchOnOk: [() => writeProvision2Meals(values)],
    });
  };

  handleSubmit = values => {
    this.showVerifyDialog(values);
  };

  getCalculation = _.debounce(this.props.getCalculation, 300, {
    leading: false,
    trailing: true,
  });

  render() {
    const { controlInfoDT } = this.props;
    return (
      <React.Fragment>
        <Filter title={'Provision 2'} />
        <Main {...this.mainProps}>
          <TitledCard title={'Options'}>
            <Provision2Form
              initialValues={this.initialValues}
              onSubmit={this.handleSubmit}
              getCalculation={this.getCalculation}
              controlInfoDT={controlInfoDT}
            />
          </TitledCard>
        </Main>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loadingCalculation: Provision2Selectors.getLoadingCalculation(state),
  writeError: Provision2Selectors.getWriteError(state),
  loadingWriteMeals: Provision2Selectors.getLoadingWriteMeals(state),
  writeSuccessful: Provision2Selectors.getWriteSuccessful(state),
  sitesMap: CommonStateSelectors.getSitesMap(state),
  itemsMap: Provision2Selectors.getServedItemsMap(state),
  controlInfoDT: CommonStateSelectors.actualDT(state),
});

const mapDispatchToProps = {
  writeProvision2Meals: Provision2Actions.writeProvision2Meals,
  resetWriteError: Provision2Actions.resetWriteError,
  resetWriteSuccessful: Provision2Actions.resetWriteSuccessful,
  setNotificationDialog,
  getCalculation: Provision2Actions.getCalculation,
  getControlInfo: ControlInfoActions.getControlInfo,
};

Provision2 = connect(
  mapStateToProps,
  mapDispatchToProps
)(Provision2);

export { Provision2 };



// WEBPACK FOOTER //
// ./src/pages/provision2/Provision2.js